// Disables Buttons If Sim Running
export const disable = (simStatus) => {
	return simStatus ? true : false;
};
